let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lOzE3")).then(() => parcelRequire('iB9F0'));